export const updateMetricsByUserID = ({ id, metrics, statusMetrics }) => {
  return {
    type: 'UPDATE_METRICS_BY_USER_ID',
    id,
    metrics,
    statusMetrics,
  };
};
